(function () {
  // ---------- SETTINGS ----------
  var ONLY_ON = ['/collections/all', '/collections/all/'];
  var SESSION_FLAG = 'kfr_all_randomized_this_visit';
  if (!ONLY_ON.includes(location.pathname)) return;
  if (sessionStorage.getItem(SESSION_FLAG) === '1') return;

  var sortBy = new URLSearchParams(location.search).get('sort_by');
  if (sortBy && sortBy !== 'relevance') return;

  var GRID_CONTAINER = '[data-randomize-grid]';
  var UL_SELECTOR = '#product-grid';
  var ITEM_SELECTOR = ':scope > li';
  var PAGINATION_SELECTOR = '.pagination__list a, .pagination a';

  // Env-aware tuning
  var isMobile = window.matchMedia && matchMedia('(max-width: 767px)').matches;
  var conn = navigator.connection || {};
  var saveData = !!conn.saveData;
  var slowConn = /^(slow-2g|2g)$/i.test(conn.effectiveType || '');

  // Sample fewer pages on mobile / slow / data-saver
  var SAMPLE_PAGES = isMobile || saveData || slowConn ? 3 : 6;

  // ---------- HELPERS ----------
  function shuffle(a){ for(let i=a.length-1;i>0;i--){ const j=Math.floor(Math.random()*(i+1)); [a[i],a[j]]=[a[j],a[i]];} return a; }

  function getPerPage(ul){ return ul ? ul.querySelectorAll(ITEM_SELECTOR).length : 0; }

  function getTotalPagesFromDOM(){
    var links = Array.from(document.querySelectorAll(PAGINATION_SELECTOR))
      .map(a => parseInt(a.textContent.trim(), 10))
      .filter(n => !isNaN(n));
    if (links.length) return Math.max.apply(null, links);
    var pg = document.querySelector('[data-pagination-pages],[data-total-pages]');
    if (pg) {
      var n = parseInt(pg.getAttribute('data-pagination-pages') || pg.getAttribute('data-total-pages'), 10);
      if (!isNaN(n)) return n;
    }
    return 1;
  }

  function parseItemsFromHTML(html){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var ul = doc.querySelector(UL_SELECTOR);
    if (!ul) return [];
    return Array.from(ul.querySelectorAll(ITEM_SELECTOR));
  }

  function isRealProductLI(li){
    if (!(li instanceof Element)) return false;
    const href = li.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    if (!href) return false;
    if (li.className.match(/placeholder|skeleton|load|loading|spinner/i)) return false;
    return true;
  }

  // Keep the card visible immediately; don't force images eager on mobile
  function makeImmediatelyVisible(li){
    li.classList.remove('scroll-trigger','animate--slide-in','scroll-trigger--offscreen');
    li.removeAttribute('style'); // removes --animation-order
    li.querySelectorAll('.scroll-trigger, .animate--slide-in').forEach(el => el.classList.remove('scroll-trigger','animate--slide-in'));
  }

  function hydrateImages(root){
    root.querySelectorAll('img').forEach(img => {
      // Promote data-src/srcset if missing real attrs (so images actually appear)
      if (!img.src && img.dataset.src) img.src = img.dataset.src;
      if (!img.srcset && img.dataset.srcset) img.srcset = img.dataset.srcset;
      // Desktop can afford eager; mobile stays lazy to save data
      if (!isMobile) { try { img.loading = 'eager'; } catch(e){} }
      img.classList.remove('lazyloading'); // avoid stuck state
      // keep `lazyload` class on mobile so native/lazy loader can decide
      if (!isMobile) img.classList.remove('lazyload');
    });
  }

  function prepareImportedCard(li){
    makeImmediatelyVisible(li);
    hydrateImages(li);
    return li;
  }

  function uniqueByHandle(nodes){
    const seen = new Set();
    const out = [];
    nodes.forEach(n => {
      const a = n.querySelector('a[href*="/products/"]');
      const key = a ? a.getAttribute('href').replace(/\?.*$/,'') : '';
      if (key && !seen.has(key)) { seen.add(key); out.push(n); }
    });
    return out;
  }

  async function fetchPage(page){
    const url = new URL(location.href);
    url.searchParams.set('page', page);
    try {
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!res.ok) return [];
      const text = await res.text();
      return parseItemsFromHTML(text);
    } catch(e) { return []; }
  }

  async function buildGlobalRandom(){
    var container = document.querySelector(GRID_CONTAINER);
    var ul = container && container.querySelector(UL_SELECTOR);
    if (!container || !ul) return false;

    var perPage = getPerPage(ul) || 16;
    var totalPages = getTotalPagesFromDOM();

    // Start with current page items
    var pool = Array.from(ul.querySelectorAll(ITEM_SELECTOR));

    // Sample additional pages if available
    if (totalPages > 1) {
      var pages = Array.from({length: totalPages}, (_, i) => i + 1);
      var cur = parseInt(new URL(location.href).searchParams.get('page') || '1', 10);
      pages = pages.filter(p => p !== cur);
      shuffle(pages);
      var pick = pages.slice(0, Math.min(SAMPLE_PAGES, pages.length));
      const results = await Promise.all(pick.map(p => fetchPage(p)));
      results.forEach(arr => pool.push(...arr));
    }

    pool = pool.filter(isRealProductLI);
    pool = uniqueByHandle(pool);
    if (!pool.length) return false;

    shuffle(pool);
    var chosen = pool.slice(0, perPage);

    // Swap in the randomized first page
    container.style.minHeight = container.offsetHeight + 'px';
    ul.innerHTML = '';
    var frag = document.createDocumentFragment();
    chosen.forEach(n => {
      var node = document.importNode(n, true);
      node = prepareImportedCard(node);
      frag.appendChild(node);
    });
    ul.appendChild(frag);
    container.style.minHeight = '';

    sessionStorage.setItem(SESSION_FLAG, '1');
    return true;
  }

  // ---------- DEFER STRATEGY ----------
  // Run after first user interaction or when the main thread is idle—whichever comes first.
  function scheduleDeferred(fn){
    var fired = false;
    function fire(){ if (fired) return; fired = true; remove(); fn(); }
    function remove(){
      window.removeEventListener('scroll', fire, {passive:true});
      window.removeEventListener('touchstart', fire, {passive:true});
      window.removeEventListener('mousemove', fire, {passive:true});
    }
    window.addEventListener('scroll', fire, {passive:true});
    window.addEventListener('touchstart', fire, {passive:true});
    window.addEventListener('mousemove', fire, {passive:true});

    // Idle fallback
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => fire(), { timeout: isMobile ? 2000 : 1000 });
    } else {
      setTimeout(() => fire(), isMobile ? 2000 : 1000);
    }
  }

  function init(){
    var container = document.querySelector(GRID_CONTAINER);
    if (!container) return;

    // If the user never interacts, we still randomize soon (but not immediately)
    scheduleDeferred(() => {
      // Observe briefly in case the theme injects the grid late
      buildGlobalRandom();
      var mo = new MutationObserver(() => {
        if (sessionStorage.getItem(SESSION_FLAG) === '1') { mo.disconnect(); return; }
        buildGlobalRandom();
      });
      mo.observe(container, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 8000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
